<template>
  <div class="container page" style="background-color: #000000;">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <span class="period-number">{{v.expect}}</span>
            <span class="period-number">{{v.name}}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
            <div>
              <span>{{$t("reservation.result")}}</span>
              <span class="ressquareBox">{{ v.size }}</span>
              <span class="ressquareBox">{{ v.double }}</span>
             
            </div>
          
            </div>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
            <div>
              <span>{{$t("q36")}}</span>
              <span class="ressquareBox" v-for="citem in v.data" :key="citem.id">{{ calcSize(citem.type) }}</span>
              
             
            </div>
          
            </div>
          </div>
          <div class="topInfo">
        
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
            <span>{{$t("reservation.money")}}：{{v.money}}</span>
          </div>
       <!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { resolveAssetUrl } from "../../http";

export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: "",
      double: "",
      size: "",
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      this.getUserGameList().finally(() => {
        this.isLoading = false;
        this.$toast(this.$t("reservation.refresh"));
      });
    },
    calcSize(el) {
      const map = {
        big: this.$t("reservation.big"),
        small: this.$t("reservation.small"),
        one: this.$t("reservation.one"),
        two: this.$t("reservation.two"),
      };
      return map[el] || el || "";
    },
    normalizeList(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "object") return Object.keys(raw).map((k) => raw[k]);
      return [];
    },
    buildResultLabels(opencode) {
      const codes = Array.isArray(opencode)
        ? opencode.map((n) => Number(n) || 0)
        : [];
      if (codes.length < 3) {
        return { size: "", double: "" };
      }
      const sum = codes[0] + codes[1] + codes[2];
      let size = "";
      if (sum >= 11 && sum <= 18) size = this.$t("reservation.big");
      else if (sum >= 3 && sum <= 10) size = this.$t("reservation.small");
      const double =
        sum % 2 === 0
          ? this.$t("reservation.two")
          : this.$t("reservation.one");
      return { size, double };
    },
    getUserGameList() {
      return this.$http({
        method: "get",
        url: "user_get_game_list",
      })
        .then((res) => {
          if (res && res.code === 200) {
            const clist = this.normalizeList(res.data);
            this.list = clist.map((item) => {
              const labels = this.buildResultLabels(item && item.opencode);
              return {
                ...item,
                ico: resolveAssetUrl((item && item.ico) || ""),
                size: labels.size,
                double: labels.double,
                data: Array.isArray(item && item.data) ? item.data : [],
              };
            });
          } else if (res && res.code === 401) {
            this.list = [];
            this.$toast(res.msg);
          } else {
            this.list = [];
          }
        })
        .catch(() => {
          this.list = [];
        });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserGameList();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #000000;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 24px;
  margin: 20px 14px;
  background: #141414;
  border-radius: 16px;
  line-height: 60px;
  color: #c9a84c;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #c9a84c;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #666;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list  .period-number{
  margin-left: 0;
  margin-right: 20px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #c9a84c;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #c9a84c;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: #c9a84c;
    color: #000;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
    white-space: nowrap;
}
</style>
